import _ from 'lodash';

export const ACTION_TYPES = {
    CHANGE_PAGE: 'pagination/CHANGE_PAGE',
    SET_PAGINATION_IDS: 'pagination/SET_PAGINATION_IDS',
    REMOVE_ID_FROM_PAGE: 'pagination/REMOVE_ID_FROM_PAGE',
    SET_COUNT: 'pagination/SET_COUNT'
};

const reducer = (state = {}, action) => {
    const { type } = action;
    switch (type) {
        case ACTION_TYPES.CHANGE_PAGE: {
            const { currentPage, key } = action;
            state[key] = { ...state[key], currentPage };
            return { ...state };
        }
        case ACTION_TYPES.SET_PAGINATION_IDS: {
            const { currentPage, key, ids } = action;
            if (currentPage === undefined) {
                throw new Error(type + ': currentPage is undefined in action \n' + JSON.stringify(action, null, 4));
            }
            return {
                ..._.setWith(state, key + '.pages.' + currentPage, ids, Object)
            };
        }
        case ACTION_TYPES.SET_COUNT: {
            const { key, count } = action;
            state[key] = { ...state[key], count };
            return { ...state };
        }
        case ACTION_TYPES.REMOVE_ID_FROM_PAGE: {
            const { currentPage, key, id } = action;
            const dirtyIds = _.get(state, key + '.pages.' + currentPage, []);
            const cleanIds = dirtyIds.filter(el => el !== id);
            _.setWith(state, key + '.pages.' + currentPage, cleanIds, Object);
            if (state[key].count > 0) {
                --state[key].count;
            }
            return { ...state };
        }
        default:
            return state;
    }
};

export default reducer;



/** WEBPACK FOOTER **
 ** ../src/dash/front/reducers/pagination.js
 **/